module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Boswil-a2be05aad8b06c8731b3f7220810cb85.svg";